import { render, staticRenderFns } from "./inventory-orders.vue?vue&type=template&id=0ae2d958"
import script from "./inventory-orders.vue?vue&type=script&lang=js"
export * from "./inventory-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports